import React from "react";
import { BrowserRouter as Router, Routes, Route, useSearchParams } from "react-router-dom";
import Chatbot from "./Chatbot";
import LandingPage from "./LandingPage";
import SearchBox from "./SearchBox";
import Results from "./Results";

function HomeRoute() {
  const [params] = useSearchParams();
  const websiteRef = params.get("websiteRef");
  if (!websiteRef?.trim()) return <LandingPage />;
  return <Chatbot />;
}

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<HomeRoute />} />
        <Route path="/source_finder" element={<h1>Hello World</h1>} />
        <Route path="/source_finder/search_box" element={<SearchBox />} />
        <Route path="/source_finder/results" element={<Results />} />
      </Routes>
    </Router>
  );
}

export default App;
